<template>
  <div class="component articleTitle stock-top">
    <div class="stock-header">
      <div class="line inline"></div>
      <div class="text inline">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '标题'
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate() { },
  created() { },
  beforeMount() { },
  mounted() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  methods: {}
}
</script>

<style lang='scss' scoped>
@import "@/styles/variables.scss";
.component.articleTitle {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .stock-header {
    display: flex;
    align-items: center;
    .line {
      width: 4px;
      height: 20px;
      background: $mainBg;
      margin-right: 8px;
    }

    .text {
      font-size: 18px;
      font-weight: 600;
      line-height: 28px;
      color: rgba(19, 20, 20, 1);
    }
  }
}
</style>
